import axios, { type AxiosInstance } from 'axios';
import type { PlatformAdapter } from './platform';
import { installInterceptors } from './interceptors';

/**
 * Create a configured Axios API client using the given PlatformAdapter.
 *
 * The returned client has:
 * - baseURL set to adapter.getApiBaseUrl()
 * - Request interceptor that attaches Bearer token
 * - Response interceptors for 401 (refresh + retry), 429 (rate limit), 440 (session expired)
 */
export function createApiClient(adapter: PlatformAdapter): AxiosInstance {
  const client = axios.create({
    baseURL: adapter.getApiBaseUrl(),
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });

  installInterceptors(client, adapter);

  return client;
}
